/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./adx-white-list.vue?vue&type=template&id=38bbc202&scoped=true&"
import script from "./adx-white-list.vue?vue&type=script&lang=js&"
export * from "./adx-white-list.vue?vue&type=script&lang=js&"
import style0 from "./adx-white-list.vue?vue&type=style&index=0&id=38bbc202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbc202",
  null
  
)

export default component.exports